import { StyleSheet } from '@react-pdf/renderer';

export const pjrPdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 28,
    fontFamily: 'Helvetica',
    fontSize: 9
  },

  // ── Header ──────────────────────────────────────────────────────────────────
  header: {
    marginBottom: 14,
    borderBottomWidth: 2,
    borderBottomColor: '#0d3b66',
    paddingBottom: 10
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 6
  },
  logoImage: {
    width: 50,
    height: 50,
    objectFit: 'contain'
  },
  headerTitleBlock: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 10
  },
  reportTitle: {
    fontSize: 16,
    fontFamily: 'Helvetica-Bold',
    color: '#0d3b66',
    textAlign: 'center'
  },
  reportSubtitle: {
    fontSize: 8,
    color: '#5f6c7c',
    textAlign: 'center',
    marginTop: 3
  },
  formId: {
    fontSize: 8,
    color: '#5f6c7c',
    textAlign: 'right'
  },

  // ── Job Info Table ───────────────────────────────────────────────────────────
  infoTable: {
    borderWidth: 1,
    borderColor: '#cfd8e3',
    marginBottom: 10
  },
  infoRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e8edf2'
  },
  infoRowLast: {
    flexDirection: 'row'
  },
  infoCell: {
    flex: 1,
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: '#e8edf2'
  },
  infoCellLast: {
    flex: 1,
    padding: 4
  },
  infoCellLabel: {
    fontSize: 7,
    color: '#5f6c7c',
    textTransform: 'uppercase',
    marginBottom: 2,
    fontFamily: 'Helvetica-Bold'
  },
  infoCellValue: {
    fontSize: 9,
    color: '#1a1a2e',
    fontFamily: 'Helvetica'
  },

  // ── Section Heading ──────────────────────────────────────────────────────────
  sectionHeading: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: '#ffffff',
    backgroundColor: '#0d3b66',
    padding: '4 8',
    marginBottom: 6,
    marginTop: 10
  },

  // ── Data Table ───────────────────────────────────────────────────────────────
  dataTable: {
    borderWidth: 1,
    borderColor: '#cfd8e3',
    marginBottom: 10
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#e8edf2'
  },
  tableHeaderCell: {
    flex: 1,
    padding: '3 4',
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    color: '#0d3b66',
    borderRightWidth: 1,
    borderRightColor: '#cfd8e3',
    textAlign: 'center'
  },
  tableRow: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderTopColor: '#e8edf2'
  },
  tableCell: {
    flex: 1,
    padding: '3 4',
    fontSize: 8,
    borderRightWidth: 1,
    borderRightColor: '#e8edf2',
    textAlign: 'center'
  },
  tableCellLeft: {
    flex: 1,
    padding: '3 4',
    fontSize: 8,
    borderRightWidth: 1,
    borderRightColor: '#e8edf2'
  },
  tableCellLast: {
    flex: 1,
    padding: '3 4',
    fontSize: 8,
    textAlign: 'center'
  },

  // ── KV Pairs ─────────────────────────────────────────────────────────────────
  kvGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 8
  },
  kvItem: {
    width: '25%',
    marginBottom: 6,
    paddingRight: 8
  },
  kvItemHalf: {
    width: '50%',
    marginBottom: 6,
    paddingRight: 8
  },
  kvLabel: {
    fontSize: 7,
    color: '#5f6c7c',
    textTransform: 'uppercase',
    fontFamily: 'Helvetica-Bold',
    marginBottom: 2
  },
  kvValue: {
    fontSize: 9,
    color: '#1a1a2e'
  },

  // ── Narrative Log ─────────────────────────────────────────────────────────────
  logEntry: {
    marginBottom: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#0d6efd',
    paddingLeft: 8
  },
  logDate: {
    fontSize: 8,
    fontFamily: 'Helvetica-Bold',
    color: '#0d3b66',
    marginBottom: 3
  },
  logText: {
    fontSize: 8,
    color: '#333',
    lineHeight: 1.5
  },

  // ── Comments / Notes ──────────────────────────────────────────────────────────
  commentsBox: {
    borderWidth: 1,
    borderColor: '#cfd8e3',
    padding: 8,
    minHeight: 60,
    marginBottom: 10
  },
  commentsText: {
    fontSize: 9,
    color: '#333',
    lineHeight: 1.5
  },

  // ── Footer ────────────────────────────────────────────────────────────────────
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 28,
    right: 28,
    borderTopWidth: 1,
    borderTopColor: '#cfd8e3',
    paddingTop: 6,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  footerText: {
    fontSize: 7,
    color: '#9ca3af'
  },

  // ── Misc ──────────────────────────────────────────────────────────────────────
  calcValueBox: {
    backgroundColor: '#e8f4fd',
    padding: '3 6',
    borderRadius: 3,
    fontSize: 9,
    color: '#0d3b66',
    fontFamily: 'Helvetica-Bold'
  },
  pageBreak: {
    marginTop: 20
  }
});
